

export const findCotizacionesAll = () => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", '');
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/getCotizaciones`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}


export const findCotizaciones = (id, filter='') => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", id);
    if (filter) {
      formdata.append("filter", filter);
    }
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/getCotizaciones`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}